module.exports = __webpack_public_path__ + "img/av266.dd1369ec.png";